import React, { FC } from "react";
import classNames from "classnames";
import { Fade } from "react-awesome-reveal";
import { SbGatsbyStory, useStoryblokState } from "gatsby-source-storyblok";
import { DEFAULT_FADE_DURATION } from "@app/constants";
import { IArticleContent } from "./models";
import { useRelatedArticles } from "./components/useRelatedArticles";
import { Hero } from "./components/hero/Hero";
import { Body } from "./components/body/Body";
import { ShareLinks } from "./components/share-links/ShareLinks";
import { RelatedPublications } from "./components/related-publications/RelatedPublications";

type Props = {
  content: SbGatsbyStory & {
    slug: string;
    uuid: string;
  };
};

export const ArticlePage: FC<Props> = ({ content }) => {
  const slug = content.slug;
  const uuid = content.uuid;
  const data = useStoryblokState(content) as unknown as IArticleContent;
  const relatedArticles = useRelatedArticles(
    uuid,
    data.content.category,
    data.content.tags,
  );

  return (
    <div
      className={classNames(
        "flex flex-col items-center px-5 pb-20 pt-40",
        "lg:px-16 lg:pb-25 lg:pt-60",
        "xl:px-24 xl:py-40",
      )}
    >
      <div className={classNames("w-full", "xl:max-w-container")}>
        <Fade duration={DEFAULT_FADE_DURATION} triggerOnce>
          <Hero {...{ ...data.content, slug }} />
        </Fade>
        <Fade duration={DEFAULT_FADE_DURATION} triggerOnce>
          <Body data={data.content.body} />
          <ShareLinks
            articleTitle={slug}
            className={classNames(
              "mt-15",
              "lg:mx-auto lg:max-w-container-small",
            )}
          />
        </Fade>
        <Fade duration={DEFAULT_FADE_DURATION} triggerOnce>
          <RelatedPublications publications={relatedArticles} />
        </Fade>
      </div>
    </div>
  );
};
